import { villusBugsnag, craftPreview, bearerToken } from '@digitalnatives/villus-plugins';
import { defaultPlugins, definePlugin } from 'villus';

export default defineGraphqlConfig(() => {
    const config = useRuntimeConfig();
    return {
        villus: {
            url: config.public.apiEndpoint,
            use: [explicitUserAgent(), villusBugsnag(), bearerToken(config.public.apiToken), craftPreview(), ...defaultPlugins()],
        }
    };
});

const explicitUserAgent = () => {
    return definePlugin(({ opContext}) => {
        // FIXME: workerd does not have its own default User-Agent, make sure we always set a User-Agent!
        // if (false) {
        // opContext.headers['User-Agent'] = 'Digital-Natives/GraphQL-Client (villus; Fetch-API) (+https://www.digitalnatives.nl)';
        // }
    });
};
